import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';

export const AddButton = ({ to, onClick, disabled, children }) => {
    const button = (
        <button type="button" className="addButton" onClick={onClick} disabled={disabled}>
            <Icon name="plus" />
            <div>{children}</div>
        </button>
    );

    if (to && !disabled) {
        return <Link to={to}>{button}</Link>;
    }

    return button;
};
